import type { DpsMiniAppBackendStep } from "@gameApp/api/types/DpsMiniAppBackend";

export function whitelistStepsCompletedCountGet(
  steps: DpsMiniAppBackendStep[],
): number {
  let count = 0;

  for (let i = 0; i < steps.length; i += 1) {
    const step = steps[i];
    const quests = step.quests;

    if (quests.every((item) => item.status === "COMPLETED")) {
      count += 1;
    }
  }

  return count;
}
